import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { PureComponent } from 'react';
import PT from 'prop-types';
import styled, { css } from 'styled-components';
import { $ as $f7dceffc5ad7768b$export$4e328f61c538687f } from '../3rdPartyModules/_react-aria/focus/dist/useFocusRing-BO5gj-B1.js';
import { $ as $3ef42575df84b30b$export$9d1611c77c2fe928 } from '../3rdPartyModules/_react-aria/utils/dist/mergeProps-Bjtexw5f.js';
import { f as focusOutline } from '../FocusIndicator/styleMixins/focusOutline-DNwtedBp.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { I as Icon } from '../Icon/Icon-CCTOGwuW.js';
import { f as angleUp, g as angleDown } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-C0k5YASI-B7bhIt-r.js';
import { T as TaktIdConsumer } from '../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';

const IconWrapper = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-storm-ui-30053921__sc-1xkqa3b-0"
})(["padding-right:", ";padding-left:", ";flex:0 0 auto;color:", ";:hover{color:", ";}:active{color:", ";}"], ({
  theme
}) => theme.spacing.small, ({
  theme
}) => theme.spacing.small, ({
  theme
}) => theme.sectionExpander.iconColor, ({
  theme
}) => theme.sectionExpander.iconColorHover, ({
  theme
}) => theme.sectionExpander.iconColorActive);
const ExtenderButton = /*#__PURE__*/styled('button').attrs(({
  onFocus,
  onBlur
}) => {
  const {
    isFocusVisible,
    focusProps
  } = $f7dceffc5ad7768b$export$4e328f61c538687f();
  return {
    /*
     *`useFocusRing()` uses `onFocus` and `onBlur` props, so `mergeProps()` must be used to
     * make sure user supplied `onFocus` and `onBlur` are also called.
    */
    ...$3ef42575df84b30b$export$9d1611c77c2fe928({
      onFocus,
      onBlur
    }, focusProps),
    focusVisible: isFocusVisible,
    type: 'button'
  };
}).withConfig({
  componentId: "sc-storm-ui-30053921__sc-1xkqa3b-1"
})(["", " display:flex;width:100%;border:1px solid transparent;text-align:initial;cursor:pointer;margin:0px;padding:", ";padding-left:", ";@media (prefers-reduced-motion:no-preference){transition:", ";}color:", ";background-color:", ";:hover{color:", ";background-color:", ";text-decoration:none;}:focus{outline:none;", "}:active{background-color:", ";}", ""], ({
  theme
}) => theme.typography.base, ({
  theme
}) => theme.spacing.medium, ({
  theme
}) => theme.spacing.micro, ({
  theme
}) => theme.sectionExpander.transition, ({
  theme
}) => theme.palette.black, ({
  theme,
  $isOpen
}) => $isOpen ? theme.sectionExpander.bgOpen : theme.sectionExpander.bgClosed, ({
  theme
}) => theme.palette.black, ({
  theme
}) => theme.sectionExpander.bgHover, ({
  focusVisible
}) => focusVisible && focusOutline, ({
  theme
}) => theme.sectionExpander.bgActive, isMobile(css(["font-size:", ";"], ({
  theme
}) => theme.typography.mobile.size.base)));
ExtenderButton.displayName = 'ExtenderButton';
const TextButtonLabel = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30053921__sc-1xkqa3b-2"
})(["flex:1 1 auto;padding-left:", ";"], ({
  theme
}) => theme.spacing.medium);
const SectionExpanderContent = /*#__PURE__*/styled.section.withConfig({
  componentId: "sc-storm-ui-30053921__sc-1xkqa3b-3"
})(["display:", ";padding:", ";background-color:", ";border-top:", ";"], ({
  $isOpen
}) => $isOpen ? 'block' : 'none', ({
  theme
}) => theme.spacing.medium, ({
  theme
}) => theme.sectionExpander.bgContent, ({
  theme
}) => theme.sectionExpander.borderTop);
SectionExpanderContent.displayName = 'SectionExpanderContent';
const bottomBorder = /*#__PURE__*/css(["border-bottom-left-radius:", ";border-bottom-right-radius:", ";"], ({
  theme
}) => theme.sectionExpander.borderRadius, ({
  theme
}) => theme.sectionExpander.borderRadius);
const lastContent = /*#__PURE__*/css([":last-child ", "{", "}"], SectionExpanderContent, bottomBorder);
const lastButtton = /*#__PURE__*/css([":last-child ", "{", "}"], ExtenderButton, bottomBorder);
const SectionExpanderWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30053921__sc-1xkqa3b-4"
})(["border:", ";box-shadow:", ";:not(:first-child){border-top:none;}:first-child,:first-child ", "{border-top-left-radius:", ";border-top-right-radius:", ";}:last-child{", "}", ""], ({
  theme
}) => theme.sectionExpander.border, ({
  theme
}) => theme.sectionExpander.boxShadow, ExtenderButton, ({
  theme
}) => theme.sectionExpander.borderRadius, ({
  theme
}) => theme.sectionExpander.borderRadius, bottomBorder, ({
  $isOpen
}) => $isOpen ? css(["", ""], lastContent) : css(["", ""], lastButtton));
SectionExpanderWrapper.displayName = 'SectionExpanderWrapper';
class SectionExpander extends PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "renderIcon", () => this.props.isOpen ? /*#__PURE__*/React__default.createElement(Icon, {
      type: angleUp,
      size: "lg"
    }) : /*#__PURE__*/React__default.createElement(Icon, {
      type: angleDown,
      size: "lg"
    }));
  }
  render() {
    const {
      children,
      label,
      isOpen,
      handleClick,
      taktId,
      taktValue
    } = this.props;
    return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
      taktId: taktId,
      taktValue: taktValue,
      fallbackId: createStormTaktId('section-expander')
    }, ({
      getDataTaktAttributes
    }) => /*#__PURE__*/React__default.createElement(SectionExpanderWrapper, {
      $isOpen: isOpen
    }, /*#__PURE__*/React__default.createElement(ExtenderButton, _extends({}, getDataTaktAttributes({
      taktIdSuffix: 'extender-button'
    }), {
      tabIndex: 0,
      "aria-expanded": isOpen,
      $isOpen: isOpen,
      onClick: handleClick
    }), /*#__PURE__*/React__default.createElement(TextButtonLabel, null, label), /*#__PURE__*/React__default.createElement(IconWrapper, null, " ", this.renderIcon(), " ")), /*#__PURE__*/React__default.createElement(SectionExpanderContent, {
      $isOpen: isOpen
    }, children)));
  }
}
_defineProperty(SectionExpander, "propTypes", {
  /**
   * The content within the SectionExpander.
   */
  children: PT.node.isRequired,
  /**
   * The SectionExpander Button label.
   */
  label: PT.node.isRequired,
  /**
   * Denotes if the InlineExapnder is open or closed.
   */
  isOpen: PT.bool.isRequired,
  /**
   * The click event handler. Used to toggle state.
   */
  handleClick: PT.func
});
_defineProperty(SectionExpander, "defaultProps", {
  handleClick: undefined
});

export { SectionExpander as S };
//# sourceMappingURL=SectionExpander-eFuvTT26.js.map
